import { render, staticRenderFns } from "./TabSingle.vue?vue&type=template&id=3eb60034&scoped=true&"
import script from "./TabSingle.vue?vue&type=script&lang=js&"
export * from "./TabSingle.vue?vue&type=script&lang=js&"
import style0 from "./TabSingle.vue?vue&type=style&index=0&id=3eb60034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb60034",
  null
  
)

export default component.exports